module.exports = __webpack_public_path__ + "media/images/athletes/1628-af093f1a66373387d272c482809df45f.png";